<template>
  <div class="wg-sites-filter">
    <!-- Filter tabs -->
    <div class="wg-sites-filter__tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        class="wg-sites-filter__tab"
        :class="{ 'wg-sites-filter__tab--active': tab.key === value }"
        @click="$emit('input', tab.key)">
        <span
          v-if="tab.color"
          class="wg-status-dot"
          :style="whiteGloveStatusDotStyle(tab.color)"></span>
        {{ tab.label }}
        <span class="wg-sites-filter__tab-count">{{ tab.count }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import {
  WHITE_GLOVE_SITE_STATUS,
  whiteGloveStatusDotStyle,
} from '@/utils/whiteGloveSiteList'

const S = WHITE_GLOVE_SITE_STATUS

export default {
  methods: {
    whiteGloveStatusDotStyle,
  },
  props: {
    value: {
      type: String,
      default: 'all',
    },
    counts: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tabs () {
      const c = this.counts || {}
      return [
        { key: 'all', label: 'All sites', count: c.all ?? 0, color: null },
        { key: 'action', label: S.action.tabLabel, count: c.action ?? 0, color: S.action.color },
        { key: 'progress', label: S.progress.tabLabel, count: c.progress ?? 0, color: S.progress.color },
        { key: 'review', label: S.review.tabLabel, count: c.review ?? 0, color: S.review.color },
        { key: 'complete', label: S.complete.tabLabel, count: c.complete ?? 0, color: S.complete.color },
        // { key: 'issues', label: S.issues.tabLabel, count: c.issues ?? 0, color: S.issues.color },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.wg-sites-filter {
  margin-bottom: 28px;

  &__tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
  }

  &__tab {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 20px;
    border: 1px solid #ccc;
    font-size: 13px;
    color: #444;
    cursor: pointer;
    background: white;
    font-family: inherit;
    line-height: inherit;

    &--active {
      background: var(--v-gray2Color-base);
      color: white;
      border-color: var(--v-gray2Color-base);

      .wg-sites-filter__tab-count {
        color: #444;
      }
    }
  }

  &__tab-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #f7f5fb;
    padding: 4px 10px;
    border-radius: 20px;
    font-weight: 700;
  }
}
</style>
